<template>
    <div class="d-flex gap20">

      <div style="flex: 1;">
        <div class="step-title-label">Select readability level</div>
        <div class="mt-2">Fine-tune your writing style and select from Easy, Standard, Technical, or Academic readability levels to match your audience.</div>
      </div>

      <div style="flex: 2;">
        <v-select
          class="readability-level-select"
          outlined
          dense
          hide-details
          :full-width="false"
          color="green7Color"
          :disabled="isDemo"
          :value="readabilityLevel"
          :items="readabilityLevelOptions"
          item-text="text"
          item-value="value"
          placeholder="None"
          style="max-width: 300px;"
          @change="$emit('update:readabilityLevel', $event);"
        >
        <template v-slot:item="{ item }">
          <div class="p-4">
            <div class="mb-2"><strong>{{item.text}}</strong></div>
            {{item.description}}
            
          </div>
        </template>
        </v-select>
      </div>

    </div>
</template>

<script>

export default {
    name: 'ConfigReadabilityLevel',
    props: [
        'isDemo',

        'readabilityLevelOptions',
        'readabilityLevel',
    ],
}
</script>

<style lang="scss" scoped>
.readability-level-select {
  .v-menu__content {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
}
</style>